export const LOGIN_REQUEST = 'LOGIN_REQUEST'

export const LOGOUT_REQUEST = 'LOGOUT_REQUEST'

export const INITIALISE_APPLICATION_REQUEST = 'INITIALISE_APPLICATION_REQUEST'

export const RELOAD_APPLICATION_REQUEST = 'RELOAD_APPLICATION_REQUEST'

export const UPDATE_APPLICATION_REQUEST = 'UPDATE_APPLICATION_REQUEST'

export const SET_VIEW_CONFIGURATION = 'SET_VIEW_CONFIGURATION'

export const SET_FNA_CONFIGURATION = 'SET_FNA_CONFIGURATION'

export const SET_VERSION = 'SET_VERSION'

export const SET_ALLOWED_AGENT_TYPES = 'SET_ALLOWED_AGENT_TYPES'

export const INITIALISE_APPLICATION_SUCCESS = 'INITIALISE_APPLICATION_SUCCESS'

export const INITIALISE_APPLICATION_FAILED_WITH_NO_INTERNET = 'INITIALISE_APPLICATION_FAILED_WITH_NO_INTERNET'

export const INITIALISE_APPLICATION_FAILED_WITH_UPDATE_APP = 'INITIALISE_APPLICATION_FAILED_WITH_UPDATE_APP'

export const INITIALISE_APPLICATION_FAILED_WITH_UPDATE_DATABASE = 'INITIALISE_APPLICATION_FAILED_WITH_UPDATE_DATABASE'

export const INITIALISE_APPLICATION_SERVER_IS_DOWN = 'INITIALISE_APPLICATION_SERVER_IS_DOWN'

export const APP_FAILED_SECURITY_POLICY = 'APP_FAILED_SECURITY_POLICY'

export const GENERATE_PDF_REQUEST = 'GENERATE_PDF_REQUEST'

export const GENERATE_PDF_SUCCESS = 'GENERATE_PDF_SUCCESS'

export const GENERATE_PDF_FAILURE = 'GENERATE_PDF_FAILURE'

export const SET_SELECTED_REMOTE_SELLING = 'SET_SELECTED_REMOTE_SELLING'

export const RESET_SELECTED_REMOTE_SELLING = 'RESET_SELECTED_REMOTE_SELLING'

export const START_REMOTE_SELLING = 'START_REMOTE_SELLING'

export const START_STANDARD_SELLING = 'START_STANDARD_SELLING'

export const CLICK_HOME_BUTTON = 'CLICK_HOME_BUTTON'
export const REDIRECT_MA_PAGE = 'REDIRECT_MA_PAGE'
export const REDIRECT_OPTY_PAGE = 'REDIRECT_OPTY_PAGE'
export const SET_ENABLE_MA_PAGE = 'SET_ENABLE_MA_PAGE'

export const setEnableMaPage = (enableMaPage) => ({
  type: SET_ENABLE_MA_PAGE,
  payload: enableMaPage,
})

export const SET_ENABLE_RETRIEVE_CUSTOMER_POLICY = 'SET_ENABLE_RETRIEVE_CUSTOMER_POLICY'

export const setEnableRetrieveCustomerPolicy = (enableRetrieveCustomerPolicy) => ({
  type: SET_ENABLE_RETRIEVE_CUSTOMER_POLICY,
  payload: enableRetrieveCustomerPolicy,
})

export const RESET_IS_SOCIAL = 'RESET_IS_SOCIAL'

export const loginRequest = () => ({
  type: LOGIN_REQUEST,
})

export const logoutRequest = () => ({
  type: LOGOUT_REQUEST,
})

export const initialiseApplicationRequest = (dbLocalUrl) => ({
  type: INITIALISE_APPLICATION_REQUEST,
  dbLocalUrl,
})

export const setViewConfiguration = (viewConfiguration) => ({
  type: SET_VIEW_CONFIGURATION,
  payload: viewConfiguration,
})

export const setFnaConfiguration = (fnaConfiguration) => ({
  type: SET_FNA_CONFIGURATION,
  payload: fnaConfiguration,
})

export const setAllowedAgentTypes = (allowedAgentTypes) => ({
  type: SET_ALLOWED_AGENT_TYPES,
  payload: allowedAgentTypes,
})

export const setVersion = (version) => ({
  type: SET_VERSION,
  payload: version,
})

export const reloadApplicationRequest = () => ({
  type: RELOAD_APPLICATION_REQUEST,
})

export const updateApplicationRequest = () => ({
  type: UPDATE_APPLICATION_REQUEST,
})

export const initialiseApplicationSuccess = () => ({
  type: INITIALISE_APPLICATION_SUCCESS,
})

export const initialiseApplicationFailedWithNoInternet = () => ({
  type: INITIALISE_APPLICATION_FAILED_WITH_NO_INTERNET,
})

export const initialiseApplicationFailedWithUpdateApp = () => ({
  type: INITIALISE_APPLICATION_FAILED_WITH_UPDATE_APP,
})

export const initialiseApplicationFailedWithUpdateDatabase = () => ({
  type: INITIALISE_APPLICATION_FAILED_WITH_UPDATE_DATABASE,
})

export const appFailedSecurityPolicy = () => ({
  type: APP_FAILED_SECURITY_POLICY,
})

export const generatePDFRequest = () => ({
  type: GENERATE_PDF_REQUEST,
})

export const generatePDFSuccess = () => ({
  type: GENERATE_PDF_SUCCESS,
})

export const generatePDFFailure = () => ({
  type: GENERATE_PDF_FAILURE,
})

export const initialiseApplicationServerIsDown = () => ({
  type: INITIALISE_APPLICATION_SERVER_IS_DOWN,
})

export const setSelectedRemoteSelling = () => ({
  type: SET_SELECTED_REMOTE_SELLING,
})

export const resetSelectedRemoteSelling = () => ({
  type: RESET_SELECTED_REMOTE_SELLING,
})

export const startRemoteSelling = () => ({
  type: START_REMOTE_SELLING,
})

export const startStandardSelling = () => ({
  type: START_STANDARD_SELLING,
})

export const clickHomeButton = () => ({
  type: CLICK_HOME_BUTTON,
})

export const redirectMaPage = () => ({
  type: REDIRECT_MA_PAGE,
})

export const redirectOptyPage = () => ({
  type: REDIRECT_OPTY_PAGE,
})

export const CONNECT_TO_DATABASE_REQUEST = 'CONNECT_TO_DATABASE_REQUEST'

export const CONNECT_TO_DATABASE_SUCCESS = 'CONNECT_TO_DATABASE_SUCCESS'

export const CONNECT_TO_DATABASE_FAILED = 'CONNECT_TO_DATABASE_FAILED'

export const connectToDatabaseRequest = (dbLocalUrl) => ({
  type: CONNECT_TO_DATABASE_REQUEST,
  dbLocalUrl,
})

export const connectToDatabaseSuccess = () => ({
  type: CONNECT_TO_DATABASE_SUCCESS,
})

export const connectToDatabaseFailed = () => ({
  type: CONNECT_TO_DATABASE_FAILED,
})

export const GET_PRODUCTS_REQUEST = 'PRODUCT_SELECTION/GET_PRODUCTS_REQUEST'

export const GET_PRODUCTS_SUCCESS = 'PRODUCT_SELECTION/GET_PRODUCTS_SUCCESS'

export const PATCH_PRODUCTS_SUCCESS = 'PRODUCT_SELECTION/PATCH_PRODUCTS_SUCCESS'

export const GET_PRODUCTS_FAILED = 'PRODUCT_SELECTION/GET_PRODUCTS_FAILED'

export const getProductsRequest = () => ({
  type: GET_PRODUCTS_REQUEST,
})

export const getProductsSuccess = (products) => ({
  type: GET_PRODUCTS_SUCCESS,
  payload: products,
})

export const patchProductsSuccess = (products) => ({
  type: PATCH_PRODUCTS_SUCCESS,
  payload: products,
})

export const getProductsFailed = (error) => ({
  type: GET_PRODUCTS_FAILED,
  error,
})

export const GET_RIDERS_REQUEST = 'COVERAGE_PLAN/GET_RIDERS_REQUEST'

export const GET_RIDERS_SUCCESS = 'COVERAGE_PLAN/GET_RIDERS_SUCCESS'

export const GET_RIDERS_FAILED = 'COVERAGE_PLAN/GET_RIDERS_FAILED'

export const getRidersRequest = () => ({
  type: GET_RIDERS_REQUEST,
})

export const getRidersSuccess = (riders) => ({
  type: GET_RIDERS_SUCCESS,
  payload: riders,
})

export const getRidersFailed = (error) => ({
  type: GET_RIDERS_FAILED,
  error,
})

export const GET_OCCUPATIONS_REQUEST = 'GET_OCCUPATIONS_REQUEST'

export const GET_OCCUPATIONS_SUCCESS = 'GET_OCCUPATIONS_SUCCESS'

export const GET_OCCUPATIONS_FAILED = 'GET_OCCUPATIONS_FAILED'

export const getOccupationsRequest = () => ({
  type: GET_OCCUPATIONS_REQUEST,
})

export const getOccupationsSuccess = (occupations) => ({
  type: GET_OCCUPATIONS_SUCCESS,
  payload: occupations,
})

export const getOccupationsFailed = (error) => ({
  type: GET_OCCUPATIONS_FAILED,
  error,
})

export const GET_OCCUPATION_FACTORS_REQUEST = 'COVERAGE_PLAN/GET_OCCUPATION_FACTORS_REQUEST'

export const GET_OCCUPATION_FACTORS_SUCCESS = 'COVERAGE_PLAN/GET_OCCUPATION_FACTORS_SUCCESS'

export const GET_OCCUPATION_FACTORS_FAILED = 'COVERAGE_PLAN/GET_OCCUPATION_FACTORS_FAILED'

export const getOccupationFactorsRequest = () => ({
  type: GET_OCCUPATION_FACTORS_REQUEST,
})

export const getOccupationFactorsSuccess = (occupationFactors) => ({
  type: GET_OCCUPATION_FACTORS_SUCCESS,
  payload: occupationFactors,
})

export const getOccupationFactorsFailed = (error) => ({
  type: GET_OCCUPATION_FACTORS_FAILED,
  error,
})

export const GET_MODEL_FACTORS_REQUEST = 'GET_MODEL_FACTORS_REQUEST'

export const GET_MODEL_FACTORS_SUCCESS = 'GET_MODEL_FACTORS_SUCCESS'

export const GET_MODEL_FACTORS_FAILED = 'GET_MODEL_FACTORS_FAILED'

export const getModelFactorsRequest = () => ({
  type: GET_MODEL_FACTORS_REQUEST,
})

export const getModelFactorsSuccess = (modelFactors) => ({
  type: GET_MODEL_FACTORS_SUCCESS,
  payload: modelFactors,
})

export const getModelFactorsFailed = (error) => ({
  type: GET_MODEL_FACTORS_FAILED,
  error,
})

export const GET_RIDER_PREMIUM_RATES_REQUEST = 'COVERAGE_PLAN/GET_RIDER_PREMIUM_RATES_REQUEST'

export const GET_RIDER_PREMIUM_RATES_SUCCESS = 'COVERAGE_PLAN/GET_RIDER_PREMIUM_RATES_SUCCESS'

export const GET_RIDER_PREMIUM_RATES_FAILED = 'COVERAGE_PLAN/GET_RIDER_PREMIUM_RATES_FAILED'

export const getRiderPremiumRatesRequest = () => ({
  type: GET_RIDER_PREMIUM_RATES_REQUEST,
})

export const getRiderPremiumRatesSuccess = (premiumRates) => ({
  type: GET_RIDER_PREMIUM_RATES_SUCCESS,
  payload: premiumRates,
})

export const getRiderPremiumRatesFailed = (error) => ({
  type: GET_RIDER_PREMIUM_RATES_FAILED,
  error,
})

export const PROCESSING_APP_DATA_REQUEST = 'PROCESSING_APP_DATA_REQUEST'
export const PROCESSING_APP_DATA_SUCCESS = 'PROCESSING_APP_DATA_SUCCESS'
export const PROCESSING_APP_DATA_UNSET = 'PROCESSING_APP_DATA_UNSET'
export const BACK_TO_HOME = 'BACK_TO_HOME'
export const MANAGE_LOGIN_SESSION = 'MANAGE_LOGIN_SESSION'
export const CONFIRM_EKYC = 'CONFIRM_EKYC'
export const CANCEL_EKYC = 'CANCEL_EKYC'
export const CONFIRM_IPRO_FNA = 'CONFIRM_IPRO_FNA'
export const CANCEL_NETWORK_MODAL = 'CANCEL_NETWORK_MODAL'
export const CONFIRM_SUBMIT = 'CONFIRM_SUBMIT'
export const CANCEL_SUBMIT = 'CANCEL_SUBMIT'

export const setProcessingApp = () => ({
  type: PROCESSING_APP_DATA_REQUEST,
})
export const setProcessingSuccess = () => ({
  type: PROCESSING_APP_DATA_SUCCESS,
})
export const unsetProcessing = () => ({
  type: PROCESSING_APP_DATA_UNSET,
})
export const backToHome = () => ({
  type: BACK_TO_HOME,
})
export const confirmEKYC = () => ({
  type: CONFIRM_EKYC,
})
export const cancelEKYC = () => ({
  type: CANCEL_EKYC,
})

export const confirmIproFNA = () => ({
  type: CONFIRM_IPRO_FNA,
})

export const confirmSubmit = () => ({
  type: CONFIRM_SUBMIT,
})

export const cancelSubmit = () => ({
  type: CANCEL_SUBMIT,
})

export const cancelNetworkModal = () => ({
  type: CANCEL_NETWORK_MODAL,
})

export const goToManageLoginSession = () => ({
  type: MANAGE_LOGIN_SESSION,
})

export const RESET_QUOTE_FORM = 'RESET_QUOTE_FORM'
export const resetQuoteForm = () => ({
  type: RESET_QUOTE_FORM,
})

export const RESET_DISPLAY_PRODUCT = 'RESET_DISPLAY_PRODUCT'
export const resetDisplayProduct = () => ({
  type: RESET_DISPLAY_PRODUCT,
})

// These functions are for testing purpose
export const RESET_APPLICATION_STATE = 'RESET_APPLICATION_STATE'
export const _resetApplicationState_ = () => ({
  type: RESET_APPLICATION_STATE,
})

export const UPDATE_SEND_EKYC_LINK_METHOD = 'UPDATE_SEND_EKYC_LINK_METHOD'
export const mediaActions = {
  TOGGLE_MIC: 'TOGGLE_MIC',
  TOGGLE_CAMERA: 'TOGGLE_CAMERA',
  TOGGLE_SCREEN: 'TOGGLE_SCREEN',
  TOGGLE_SHOW_CONTROLS: 'TOGGLE_SHOW_CONTROLS',
  RESET_MEDIA_CONTROL_STATE: 'RESET_MEDIA_CONTROL_STATE',
  HANGUP: 'HANGUP',
  GET_MEDIA_STATUS: 'GET_MEDIA_STATUS',
  SET_MEDIA_CONTROL_STATE: 'SET_MEDIA_CONTROL_STATE',
  CHECK_VERSION_APP: 'CHECK_VERSION_APP',
  UPDATE_MEDIA_STATE: 'UPDATE_MEDIA_STATE',
  SYNC_MEDIA_STATE: 'SYNC_MEDIA_STATE',
}
export const CHECK_VERSION_APP = 'CHECK_VERSION_APP'
export const HANGUP = 'HANGUP'
export const GET_MEDIA_STATUS = 'GET_MEDIA_STATUS'
export const SET_MEDIA_CONTROL_STATE = 'SET_MEDIA_CONTROL_STATE'
export const UPDATE_MEDIA_STATE = 'UPDATE_MEDIA_STATE'
export const setMediaControlState = (payload) => ({
  type: mediaActions.SET_MEDIA_CONTROL_STATE,
  payload,
})
export const updateMediaState = (payload) => ({
  type: mediaActions.UPDATE_MEDIA_STATE,
  payload,
})

export const syncMediaState = () => ({
  type: mediaActions.SYNC_MEDIA_STATE,
})
export const hangup = () => ({
  type: mediaActions.HANGUP,
})
export const getMediaStatus = () => ({
  type: mediaActions.GET_MEDIA_STATUS,
})

export const resetMediaControlState = () => ({
  type: mediaActions.RESET_MEDIA_CONTROL_STATE,
})

export const checkVersionAppUpdate = (payload = {}) => ({
  type: mediaActions.CHECK_VERSION_APP,
  payload,
})

export const resetISSocial = () => ({
  type: RESET_IS_SOCIAL,
})

/**
 * @param trigger_by {typeof import('quick-quote/reducers').TriggerBy}
 */
export const partnerRequesting = (trigger_by) => ({
  type: 'PARTNER_API_REQUEST',
  payload: {
    trigger_by: trigger_by,
  },
})

export const partnerRequestSuccess = () => ({ type: 'PARTNER_API_SUCCESS' })
export const partnerRequestFailure = () => ({ type: 'PARTNER_API_FAILURE' })

export const partnerUpdateUseLegacyServiceWrapper = (payload) => ({
  type: 'PARTNER_UPDATE_USE_LEGACY_SERVICE_WRAPPER',
  payload,
})

export const partnerUpdateUseLegacySubmissionWrapper = (payload) => ({
  type: 'PARTNER_UPDATE_USE_LEGACY_SUBMISSION',
  payload,
})

export const partnerUpdateFetching = (fetching_calculate, fetching_policy) => ({
  type: 'PARTNER_UPDATE_FETCHING',
  payload: {
    fetching_calculate,
    fetching_policy,
  },
})

export const partnerCalculationFetched = () => ({
  type: 'PARTNER_CALCULATION_FETCHED',
})

export const partnerPolicyFetching = () => ({
  type: 'PARTNER_POLICY_FETCHING',
})

export const partnerPolicyFetched = () => ({
  type: 'PARTNER_POLICY_FETCHED',
})

export const patchAvailableDisplayProducts = (displayProducts) => ({
  type: 'PATCH_AVAILABLE_DISPLAY_PRODUCTS',
  payload: displayProducts,
})

export const patchAvailableRiders = (riders) => ({
  type: 'PATCH_AVAILABLE_RIDERS',
  payload: riders,
})

export const updateKYCQuestion = (kyc_question) => ({
  type: 'UPDATE_KYC_QUESTION',
  payload: kyc_question,
})

export const updatePackageCanProcess = (can_process) => ({
  type: 'UPDATE_PACKAGE_CAN_PROCESS',
  payload: can_process,
})

export const updateCurrentSelectedProduct = (packageCategory, packageCode) => ({
  type: 'UPDATE_CURRENT_SELECTED_PRODUCT',
  payload: { packageCategory, packageCode },
})

export const updateFormState = (payload) => ({
  type: 'UPDATE_FORM_STATE',
  payload: {
    dirty: payload.dirty,
  },
})

export const updateSellerProfile = (seller) => ({
  type: 'UPDATE_SELLER_PROFILE',
  payload: seller,
})

export const resetSellerProfile = () => ({
  type: 'RESET_SELLER_PROFILE',
})

export const SEARCH_APP_LIST_BY_ID = 'SEARCH_APP_LIST_BY_ID'
export const searchAppListById = (payload = {}) => ({
  type: SEARCH_APP_LIST_BY_ID,
  payload,
})

export const CLONE_APP_LIST = 'CLONE_APP_LIST'
export const setCloneAppList = (payload = {}) => ({
  type: CLONE_APP_LIST,
  payload,
})

export const CLEAR_CLONE_APP_LIST = 'CLEAR_CLONE_APP_LIST'
export const clearCloneAppList = () => ({
  type: CLEAR_CLONE_APP_LIST,
})

export const SET_CLONE_APP_ID = 'SET_CLONE_APP_ID'
export const setCloneAppId = (payload = {}) => ({
  type: SET_CLONE_APP_ID,
  payload,
})

export const SET_CLONED_POLICY = 'SET_CLONED_POLICY'
export const setClonedPolicy = (payload = null) => ({
  type: SET_CLONED_POLICY,
  payload,
})

export const CLONE_APP_SEARCH_STATUS = 'CLONE_APP_SEARCH_STATUS'
export const setCloneAppSearchStatus = (payload = null) => ({
  type: CLONE_APP_SEARCH_STATUS,
  payload,
})

export const CLEAR_CLONE_APP_SEARCH_STATUS = 'CLEAR_CLONE_APP_SEARCH_STATUS'
export const clearCloneAppSearchStatus = () => ({
  type: CLEAR_CLONE_APP_SEARCH_STATUS,
})
export const GET_EIP_POLICY_DETAILS = 'GET_EIP_POLICY_DETAILS'
export const getEIPPolicyDetails = (payload = {}) => ({
  type: GET_EIP_POLICY_DETAILS,
  payload,
})

export const getCloneAppStatus = (state) => state.quickQuote.get('cloneAppSearchStatus')
